export default {"src":"/_next/static/media/av-talkdown-tutorial.82e20fbd.gif","height":936,"width":1878,"blurWidth":0,"blurHeight":0};